import React from "react";
import { Row, Col } from "antd";
import Header from "./Header";
import "../styles/components/tos.scss";

const ToS = () => (
  <>
    <Header publicHeader={true} />
    <Row className="tos-wrapper" gutter={16} type="flex" justify="space-around">
      <Col span={18}>
        <h1>شرایط استفاده از خدمات</h1>
        <div className="tos-section">
          <div className="tldr">
            <h2>تعاریف</h2>
            <ol>
              <li>سرویس: تمامی خدماتی که بر روی دامنه‌های updamus.com و updamus.ir و تمامی زیردامنه‌های آنها ارائه می‌شود.</li>
              <li>کاربر: هر حساب کاربری که با یک ایمیل معتبر در سرویس ایجاد شود.</li>
              <li>
              شرکت: شرکت پیشرو فناوران هوشمند روش که مالکیت مادی و معنوی سرویس را بر عهده دارد.
              </li>
              <li>
                در صورتی که هر گونه سوالی داشتید با{" "}
                <a href="mailto:support@updamus.com">support@updamus.com</a> در
                تماس باشید.
              </li>
            </ol>
          </div>
          <div className="tos">
            <p>
              لطفا پیش از دسترسی و یا استفاده از وب سایت ( سرویس ) آپداموس این
              موافقتنامه را با دقت مطالعه کنید.
            </p>
            <h2>تعهدات کاربر</h2>
            <p>کاربر متعهد می‌شود:</p>
            <ul>
              <li>از یک رایانامه معتبر برای ثبت‌نام در سرویس استفاده کند.</li>
              <li>مسئولیت حفظ امنیت نام کاربری و گذرواژه‌ی خود را بر عهده داشته باشد.</li>
              <li>مسئولیت تمامی فعالیت‌هایی که در حساب کاربری وی رخ می دهد را بر عهده بگیرد.</li>
              <li>در صورت مشاهده هرگونه استفاده غیرمجاز از حساب کاربری خود یا نقض امنیتی آن، شرکت را از این موضوع آگاه سازد.</li>
              <li>در صورت مشاهده هرگونه مشکل امنیتی در سرویس، شرکت را در اسرع وقت مطلع سازد.</li>
              <li>اگر به عنوان نماینده‌ای از یک شخصیت حقوقی به این توافقنامه وارد می شود، اختیارات لازم برای اعلام پایبندی خود به این توافق‌نامه را دارا باشد.</li>
              <li>با استفاده از سرویس هیچ اقدام سوئی که منجر به خسارت به شخص ثالث یا شرکت باشد را انجام ندهد.</li>
              <li>با عضویت در سرویس تمامی قوانین و تعهدات سرویس را به رسمیت می‌شناسد و با آن موافقت می‌کند.</li>
              <li>تمامی قوانین و عرف ملی و بین‌المللی نافذ به سرویس را در هر منطقه جغرافیایی را رعایت کند و هیچ‌گونه اقدامی که به هر شکل موجب ایجاد مسئولیت حقوقی یا خسارت مالی خارج از حدود تعهدات ذکر شده انجام ندهد. در صورت وقوع این امر، تمامی مسوولیت‌های حقوقی، جزائی و مالی مرتبط بر عهده کاربر است.</li>
              <li>در هرگونه مطالبه شخص ثالث، در صورت بروز خسارت توسط کاربر یا هر یک از ماموران، مدیران، کارمندان، مشاوران و نمایندگان رسمی وی، خسارت و یا هزینه های ناشی از استفاده‌ی سرویس را متقبل شود.</li>
            </ul>
            <h2>حقوق مالکیت مادی و معنوی</h2>
            <ul>
              <li>تمامی حقوق مالکیت مادی و معنوی سرویس و اطلاعات تجمیع شده عمومی و … در سرویس متعلق به شرکت می‌باشد.</li>
            </ul>
            <h2>محدوده‌ی تعهدات</h2>
            <ul>
              <li>تعهدات شرکت مشروط به التزام کاربر به رعایت تمامی قوانین استفاده از سرویس می‌باشد و اگر کاربر فعالیت‌های مغایر با قوانین استفاده از سرویس داشته باشد شرکت می‌تواند دسترسی کاربر را به صورت جزئی یا کلی سلب کند. مرجع تشخیص مغایرت شرکت می‌باشد.</li>
              <li>تعهدات شرکت صرفا محدود به تعهدات نوشته شده در تعرفه ها و محدود به همان بازه تعرفه است.</li>
            </ul>
            <h2>سلب مسئولیت</h2>
            <ul>
              <li>تمامی فعالیت‌هایی که کاربر انجام می‌دهد و اثرات خارجی آن بر روی سرویس های دیگر و شخص ثالث بر عهده کاربر است و شرکت هیچگونه مسئولیتی در قبال اینگونه ادعاها و تصمیمات نخواهد داشت.</li>
              <li>مسئولیت هرگونه تصمیم‌گیری یا ادعایی که براساس داده های سرویس انجام شود، بر عهده کاربر است و شرکت هیچگونه مسئولیتی در قبال اینگونه ادعاها و تصمیمات نخواهد داشت.</li>
            </ul>
            <h2>سیاست های پرداخت و بازپرداخت</h2>
            <ul>
              <li>با انتخاب هر یک از پلن ها شما موافقت خود را برای پرداخت ماهانه و یا سالانه مبلغ مذکور را به شرکت اعلام می‌نمایید.</li>
              <li>هر یک از پلن های سرویس به صورت پیش پرداخت می‌باشند و هزینه هر دوره قبل از شروع دوره دریافت می‌شود.</li>
              <li>پرداخت هزینه‌های سرویس از طریق سرویس و به صورت آنلاین انجام می‌شود.</li>
              <li>مادامی که کاربر اعتبار لازم تمدید پلن فعال را داشته باشد در پایان دوره پلن فعلی به صورت اتوماتیک تمدید خواهد شد مگر آنکه کاربر عدم تمایل به تمدید پلن اطلاع دهد. بدیهی است در صورت نبود موجودی کافی پلن شما تمدید نخواهد شد.</li>
              <li>در صورت اتمام بودجه تماس یا پیامک هر پلن (مطابق با پلن های روی سایت) هرگونه تماس اضافی به صورت pay-as-you-go و با مبلغ اعلامی خواهد بود و از اعتبار کاربر کسر خواهد شد. بدیهی است در صورت نبود اعتبار کافی تماسی یا ارسال پیامکی انجام نخواهد شد.</li>
              <li>اعتبار کاربر قابلیت عودت به صورت نقدی را ندارد، البته کاربر امکان استفاده از اعتبار خود در تمامی خدمات دیگر شرکت را دارد.</li>
              <li>پس از شروع هر دوره، هزینه آن دوره از اعتبار کاربر کسر می‌شود و اعتبار کسر شده غیرقابل بازگشت می باشد.</li>
              <li>شرکت حق تغییر قیمت‌های سرویس یا هرگونه سرویس وابسته را برای خود محفوظ می داند.</li>
            </ul>
            <h2>مطابقت با قوانین کشور</h2>
            <ul>
              <li>شرکت حق آن را دارد که در صورت لزوم هر گونه موردی که در دیدگاه شرکت مغایرتی با قوانین کشور جمهوری اسلامی ایران دارد یا به هر طریقی مشکل ساز می باشد را حذف کند.</li>
              <li>شرکت این حق را برای خود محفوظ می‌دارد که در هر زمان به صلاح‌دید و تشخیص خود و براساس شکایت‌ها و گزارش‌های وارده از سوی سازمان‌ها و نهادهای نافذ اینترنت و نهادها و اشخاص حقیقی و حقوقی نسبت به توقف عرضه‌ی خدمات به کاربر اقدام کند و در صورت وجود حکم مرجع ذی‌صلاح، همکاری لازم را با نهاد‌های قانونی انجام دهد.</li>
            </ul>

            <h2>سیاست‏‌های رعایت حریم شخصی</h2>
            <ul>
              <li>شرکت به اطلاعات خصوصی اشخاصى که از خدمات سایت استفاده می‏‌کنند، احترام گذاشته و از آن محافظت می‏‌کند. اطلاعات تجمیع‌شده در مانیتورهای عمومی به دلیل امکان دسترسی عمومی به اندپوینت در بستر اینترنت، جز اطلاعات خصوصی محسوب نمی‌شود.</li>
              <li>شرکت خود را ملزم به رعایت حریم شخصی کاربران می‌داند، لطفا در صورت مشاهده هرگونه تخلف، مراتب را از طریق کانال‏‌های ارتباطی ذکر شده با ما در میان بگذارید.</li>
            </ul>

            <h2>قوه قهریه</h2>
            <ul>
              <li>تمامی شرایط و قوانین مندرج، در شرایط عادی قابل اجرا است و در صورت بروز هرگونه از موارد قوه قهریه، شرکت هیچ گونه مسئولیتی ندارد.</li>
            </ul>

            <h2>موارد دیگر</h2>
            <ul>
              <li>در صورتی که هر بخش از این شرایط استفاده از خدمات توسط مراجع ذی‌صلاح نامعتبر و یا غیر قانونی و یا غیر قابل اجرا تعیین شود باقی بند ها کماکان معتبر و قابل اجرا در بالاترین حدی که قانون اجازه دهد خواهد بود.</li>
              <li>سرویس های سفارشی با امکانات متفاوت از قبیل مانیتور های بیشتر، بازه زمان کمتر و یا تماس های بیشتر قابل درخواست از طریق صحبت با پشتیبانی می باشد. </li>
              <li>شرکت حق تغییرات در سرویس من جمله حذف یا اضافه کردن امکانات را در هر برهه از زمان برای خود محفوظ می داند.</li>
              <li>شرایط استفاده از خدمات ممکن است در طول زمان تغییراتی داشته باشد. آخرین نسخه شرایط استفاده از خدمات در آدرس https://my.updamus.com/tos در دسترس می باشد.</li>
            </ul>
          </div>
          <div className="tos-contact">
            <h2>تماس با ما</h2>
            <a href="mailto:support@updamus.com">support@updamus.com</a>
          </div>
        </div>
      </Col>
    </Row>
  </>
);

export default ToS;
